import React, { useState } from "react";
import Tooltip from "../tooltip/tooltip";
import styles from "../../pages/main/mainPage.module.css";

interface IInquiryHeaderWithTooltipProps {
  text: string;
  className?: string;
}

const InquiryHeaderWithTooltip: React.FC<IInquiryHeaderWithTooltipProps> = ({
  text,
  className,
}: IInquiryHeaderWithTooltipProps) => {
  const [hoveredTooltip, setHoveredTooltip] = useState<boolean>(false);

  return (
    <p
      className={className}
      onMouseEnter={() => setHoveredTooltip(true)}
      onMouseLeave={() => setHoveredTooltip(false)}
      onFocus={() => setHoveredTooltip(true)}
      onBlur={() => setHoveredTooltip(false)}
      tabIndex={0}
    >
      <span className={`${styles.ellipsisText}`}>{text}</span>
      <Tooltip isShown={hoveredTooltip}>{text}</Tooltip>
    </p>
  );
};

export default InquiryHeaderWithTooltip;
